import React from 'react';
import DayHeader from '../DayHeader';
import WaveHeightRowDaily from './WaveHeightRowDaily';
import WaveDirectionDominantRow from './WaveDirectionDominantRow'
import WavePeriodMaxRow from './WavePeriodMaxRow'
import WindSpeedMax10mRow from './WindSpeedMax10mRow'
import WindDirection10mDominantRow from './WindDirection10mDominantRow'
import RatingRow from './RatingRow'
import Loader from '../../common/Loader';

const DailyForecastDataTable = ({forecastData, visibleUnits, spot}) => {

    if(!forecastData || !forecastData.daily){
        return (
            <div className="mt-3 mb-3 py-3 bg-gradient-to-b from-custom-darker to-custom-dark border border-custom-charcoal shadow-xl">
                <Loader size="md" text="Fetching forecast..." />
            </div>
        )
    }

    const days = forecastData.daily.time;
    const units = forecastData.daily_units;
    const dayData = forecastData.daily;
    
    return (
        <div className="mt-3 mb-3">
            <div className="overflow-auto bg-gradient-to-b from-custom-darker to-custom-dark border border-custom-charcoal shadow-xl">                    
                <table className="forecast-table w-full text-left border-collapse pb-5 sm:table-fixed">
                    <DayHeader days={days} />
                    <tbody className="divide-y divide-custom-charcoal/50">
                        {visibleUnits.overall_rating_score && (
                            <RatingRow dayData={dayData} spot={spot} />
                        ) }
                        {dayData.wave_height_max && visibleUnits.wave_height_max && (
                            <WaveHeightRowDaily dayData={dayData.wave_height_max} units={units.wave_height_max} />
                        ) }
                        {dayData.wave_period_max && visibleUnits.wave_period_max && (
                            <WavePeriodMaxRow dayData={dayData.wave_period_max} units={units.wave_period_max} />
                        ) }
                        {dayData.wave_direction_dominant && visibleUnits.wave_direction_dominant && (
                            <WaveDirectionDominantRow dayData={dayData.wave_direction_dominant} units={units.wave_direction_dominant} />
                        ) }
                        {dayData.wind_speed_10m_max && visibleUnits.wind_speed_10m_max && (
                            <WindSpeedMax10mRow dayData={dayData.wind_speed_10m_max} units={units.wind_speed_10m_max} />
                        ) }
                        {dayData.wind_direction_10m_dominant && visibleUnits.wind_direction_10m_dominant && (
                            <WindDirection10mDominantRow dayData={dayData.wind_direction_10m_dominant} units={units.wind_direction_10m_dominant} />
                        ) }
                        
                    </tbody>
                </table>
                
            </div>
        </div>
    )
}

export default DailyForecastDataTable;